import React from "react";
import PropTypes from "prop-types";
import Anchor from "./Anchor";

const Button = (props) => {
	const { children, isSubmitButton, isDisabled, isOutline, isLoading } = props;

	let css = "btn-fill btn-txt-white btn-icon-right";
	css += isSubmitButton ? " btn-green " : " btn-gray ";
	css = isOutline ? "btn-outline btn-txt-black btn-icon-right" : css;
	css += isDisabled ? " btn-inactive " : "";
	css += isLoading
		? " btn-loading iconLoading-white btn-inactive"
		: " icon-seta-right";
	return (
		<Anchor
			onClick={(e) => {
				if (!isLoading) {
					props.onClick(e);
				}
			}}
			className={css}
		>
			{children}
		</Anchor>
	);
};

Button.propTypes = {
	children: PropTypes.node,
	isSubmitButton: PropTypes.bool,
	isDisabled: PropTypes.bool,
	isOutline: PropTypes.bool,
	onClick: PropTypes.func
};

export default Button;
